import { render, staticRenderFns } from "./ObjectBasic.vue?vue&type=template&id=f297009e&scoped=true"
import script from "./ObjectBasic.vue?vue&type=script&lang=js"
export * from "./ObjectBasic.vue?vue&type=script&lang=js"
import style0 from "./ObjectBasic.vue?vue&type=style&index=0&id=f297009e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f297009e",
  null
  
)

export default component.exports